import { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { principalpageroutes as subRoutes } from "./principalpageroutes";
import LoadingPlanet from "../../../components/composed-styled-components/LoadingPlanet/LoadingPlanet";

const PrincipalPageNavigation = () => {
  return (
    <Suspense fallback={<LoadingPlanet subtitle="Loading content..." />}>
      <Routes>
        {subRoutes.map(({ path, Component, props }) => (
          <Route key={path} path={path} element={<Component {...props} />} />
        ))}
        <Route path="/*" element={<Navigate to={subRoutes[0].to} replace />} />
      </Routes>
    </Suspense>
  );
};

export default PrincipalPageNavigation;
